import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';
import axios from 'axios';

const user = getLoggedUser();
const endpoint = apiUrl + 'wallet_transaction';

async function createWallet(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(endpoint, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getAllWallets(q) {
  return fetch(endpoint + '?' + q, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getWallet(id) {
  return fetch(endpoint + '/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function updateWallet(payload, id) {
  return fetch(endpoint + '/' + id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
    body: JSON.stringify(payload),
  }).then((data) => data.json());
}

async function updateWalletFile(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'update_wallet_status', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function updateWalletTransaction(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'update_wallet_transaction', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function deleteTransaction(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'delete_wallet_transaction', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

function deleteWallet(id) {
  return fetch(endpoint + '/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function financeRejection(payload) {
  return fetch(apiUrl + 'reject_withdraw_request_by_fm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
    body: JSON.stringify(payload),
  }).then((data) => data.json());
}

export {
  createWallet,
  getAllWallets,
  getWallet,
  updateWallet,
  deleteWallet,
  updateWalletFile,
  updateWalletTransaction,
  deleteTransaction,
  financeRejection,
};
